export function isNotEmpty(value: any): boolean {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string' || Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === 'object') {
        return Object.keys(value).length > 0;
    }
    return true;
}

export function isEmpty(value: any): boolean {
    return !isNotEmpty(value)
}

export function nullToBlank(str:string | undefined): string{
    if(str === undefined || str === null){
        return "";
    }
    return str;
}
export function isBlank(value: string | null | undefined): boolean {
    return isEmpty(value) || value!.trim().length === 0;
}
export function concatPath(str1: string, str2:string, str3 = "") {
    let slash_str = "/";
    let slice_r = str1.slice(-1);
    let slice_l = str2.slice(0, 1);

    let concat_str;

    let str_left = str1;
    let str_right = str2;
    if(slash_str === slice_r && slash_str === slice_l) {
        // 末尾1文字を削除
        str_left = str_left.slice(0, -1);
        concat_str = str_left + str_right;
    } else if(slash_str !== slice_r && slash_str !== slice_l) {
        concat_str = str_left + slash_str + str_right;
    } else {
        concat_str = str_left + str_right;
    }
    return concat_str + str3;
}

export function isBeforeDate(srcDate: string | null | undefined, chkDate: string | null | undefined): boolean{
    if(isEmpty(srcDate) || isEmpty(chkDate)){
        return false;
    }
    // @ts-ignore
    const dtSource = new Date(srcDate.replace(/\//g, '-'));
    // @ts-ignore
    const dtCheck = new Date(chkDate.replace(/\//g, '-'));
    if(!dtSource || !dtCheck){
        return false;
    }
    return dtCheck < dtSource;
}

export function getTodayInputDate(): string{
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let arrToday: string[] = [];
    arrToday[0] = today.getFullYear().toString();
    if (mm < 10) {
        arrToday[1] = '0' + mm;
    }else {
        arrToday[1] = mm.toString();
    }
    if (dd < 10) {
        arrToday[2] = '0' + dd;
    }else {
        arrToday[2] = dd.toString();
    }
    return arrToday[0] + '-' + arrToday[1] + '-' + arrToday[2];
}